export default {
  setStateData: 'SET_STATE_DATA',
  setFormRef: 'SET_FORM_REF',
  uppdateMemberClassTickets: 'UPPDATE_MEMBER_CLASS_TICKETS',
  clearMainServiceData: 'CLEAR_MAIN_SERVICE_DATA',
}
